import React from 'react'
import { Card, Typography, Space, InputNumber, Tooltip, Tag } from 'antd'
import { DeleteFilled, MessageOutlined } from '@ant-design/icons'
import { Trans } from 'react-i18next'
import DisplayStock from '../common/DisplayStock'
import DisplayAmount from '../common/DisplayAmount'
import { getProductImagePath } from '../../lib/CatalogUtils'

const { Text, Paragraph } = Typography

const labelStyle = { fontSize: 11, textTransform: 'uppercase' }

const Row = ({ children, style }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 4, ...style }}>
    {children}
  </div>
)

const renderDiscount = (descuentos) => {
  if (!descuentos) return null
  return descuentos.map((d, i) => (
    <Tag key={i} color='success' style={{ margin: 0, fontSize: 11 }}>
      {d.replace(/(\.\d{2})\d*/, '$1')}
    </Tag>
  ))
}

const CartMobileProductCard = ({ record, t, onRemove, onShowDetail, debouncedChangeQty }) => (
  <Card size='small' bodyStyle={{ padding: 0 }} className='cart-mobile-product-card'>
    <div className='cart-mobile-card-header'>
      <div className='cart-mobile-card-clickable' onClick={() => onShowDetail(record)}>
        <div className='cart-mobile-card-image-block'>
          <img
            src={getProductImagePath(record)}
            className='cart-mobile-card-image'
            alt={record.codigodearticulo}
            onError={(e) => { e.target.src = '/static/images/no-image.jpg' }}
          />
        </div>

        <div className='cart-mobile-card-info'>
          <Text className='cart-mobile-card-code'>{record.codigodearticulo}</Text>
          <Paragraph
            ellipsis={{ rows: 2, tooltip: record.descripcion }}
            style={{ margin: 0, fontSize: 12, color: '#555', lineHeight: 1.4 }}
          >
            {record.descripcion}
          </Paragraph>
        </div>
      </div>

      <Tooltip title={<Trans>Remove product</Trans>}>
        <a onClick={() => onRemove(record)} className='cart-mobile-card-delete'>
          <DeleteFilled />
        </a>
      </Tooltip>
    </div>

    <div className='cart-mobile-card-body-rows'>
      <div className='cart-mobile-card-row--split'>
        <Space size={6}>
          <Text type='secondary' style={labelStyle}>{t('Stock')}</Text>
          <DisplayStock product={record} />
        </Space>
        <Space size={6}>
          <Text type='secondary' style={labelStyle}>{t('Cant.')}</Text>
          <InputNumber
            size='small'
            step={record.multiplo || 1}
            min={record.cantidadminima || 1}
            maxLength='6'
            value={record.cantidad}
            onChange={(value) => debouncedChangeQty(record, value)}
            onKeyDown={(e) => {
              const navigationKeys = [
                'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
                'Backspace', 'Delete', 'Tab', 'Home', 'End',
              ]
              if (navigationKeys.includes(e.key)) return
              if (!/^[0-9]$/.test(e.key)) e.preventDefault()
            }}
          />
        </Space>
      </div>

      <Row style={{ marginTop: 5 }}>
        <Text type='secondary' style={labelStyle}>{t('Price')}</Text>
        <Text strong style={{ fontSize: 14 }}>
          <DisplayAmount amount={record.precioFinal} currency={record.moneda} />
        </Text>
      </Row>

      {record.descuento && record.descuento.length > 0 && (
        <Row>
          <Text type='secondary' style={labelStyle}>{t('applied discounts')}</Text>
          {renderDiscount(record.descuento)}
        </Row>
      )}

      {record.observaciones && (
        <Row style={{ marginTop: 5 }}>
          <MessageOutlined style={{ color: '#999', fontSize: 12 }} />
          <Text type='secondary' italic style={{ fontSize: 11 }}>
            {record.observaciones}
          </Text>
        </Row>
      )}
    </div>
  </Card>
)

export default CartMobileProductCard
